import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Schedule } from './Schedule';
import { MonitoringZoneDto, BlockDto } from '../siteApi';
import { useUpdateZone } from '@/hooks/zoneHooks';

interface ZoneScheduleDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  zone: MonitoringZoneDto;
  projectId: string;
  companyId: string;
}

export const ZoneScheduleDialog: React.FC<ZoneScheduleDialogProps> = ({
  open,
  onOpenChange,
  zone,
  projectId,
  companyId,
}) => {
  const { mutateAsync } = useUpdateZone({ projectId, companyId });

  const handleSave = async (newBlocks: BlockDto[]) => {
    await mutateAsync({
      zoneId: zone.id!,
      form: {
        schedule: { blockSize: 15, blocks: newBlocks },
        description: zone.description,
        videoProcessorIds: zone.videoProcessors
          ?.map((vp) => vp.videoProcessorConfigId)
          .filter((id): id is string => id != null),
      },
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>Edit Schedule - {zone.description}</DialogTitle>
        </DialogHeader>
        <Schedule
          scheduleBlocks={zone.schedule?.blocks || []}
          customerId={companyId}
          projectId={projectId}
          onSave={handleSave}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ZoneScheduleDialog;
